var _circle, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSavingBank(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 20
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.0669 24.588V19.4648"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.4268 24.588H16.6288"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.7861 27.1497H27.5153"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.7861 25.8689H27.5153"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M13.4268 19.4648H16.6288"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5498 24.588H21.7518"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5498 19.4648H21.7518"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9883 24.588V19.4648"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M19.1899 24.588V19.4648"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M21.1113 24.588V19.4648"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M23.6729 24.588H26.8749"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M23.6729 19.4648H26.8749"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M24.3135 24.588V19.4648"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M26.2344 24.588V19.4648"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.5199 17.6109C13.4117 17.6948 13.3689 17.8383 13.4133 17.9678C13.4578 18.0973 13.5796 18.1842 13.7165 18.1841H26.5885C26.7253 18.1844 26.8472 18.0978 26.8919 17.9685C26.9366 17.8392 26.8942 17.6958 26.7864 17.6115L20.3677 12.5748C20.2518 12.4842 20.0891 12.4842 19.9732 12.5748L13.5199 17.6109Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSavingBank);
export default __webpack_public_path__ + "static/media/saving-bank.9e3fc292.svg";
export { ForwardRef as ReactComponent };